/* tslint:disable */
/* eslint-disable */
/**
 * Happyforce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GiftCardBatchUploadResult } from '../models';
// @ts-ignore
import type { PointsAdjustmentRequest } from '../models';
// @ts-ignore
import type { PointsLedgerEntry } from '../models';
// @ts-ignore
import type { Redemption } from '../models';
// @ts-ignore
import type { RedemptionStatus } from '../models';
// @ts-ignore
import type { RedemptionTransitionRequest } from '../models';
// @ts-ignore
import type { RewardCatalogItem } from '../models';
// @ts-ignore
import type { RewardCatalogItemRequest } from '../models';
// @ts-ignore
import type { RewardsConfiguration } from '../models';
// @ts-ignore
import type { RewardsStats } from '../models';
/**
 * RewardsApi - axios parameter creator
 * @export
 */
export const RewardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Manually adjust an employee\'s points
         * @param {PointsAdjustmentRequest} pointsAdjustmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustRewardsPoints: async (pointsAdjustmentRequest: PointsAdjustmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pointsAdjustmentRequest' is not null or undefined
            assertParamExists('adjustRewardsPoints', 'pointsAdjustmentRequest', pointsAdjustmentRequest)
            const localVarPath = `/api/v1/company/rewards/adjustments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pointsAdjustmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a catalog item
         * @param {RewardCatalogItemRequest} rewardCatalogItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRewardsCatalogItem: async (rewardCatalogItemRequest: RewardCatalogItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rewardCatalogItemRequest' is not null or undefined
            assertParamExists('createRewardsCatalogItem', 'rewardCatalogItemRequest', rewardCatalogItemRequest)
            const localVarPath = `/api/v1/company/rewards/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rewardCatalogItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a catalog item (archived if it has redemptions)
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRewardsCatalogItem: async (itemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('deleteRewardsCatalogItem', 'itemId', itemId)
            const localVarPath = `/api/v1/company/rewards/catalog/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the rewards configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/rewards/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List an employee\'s points ledger
         * @param {number} internalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsLedger: async (internalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'internalId' is not null or undefined
            assertParamExists('getRewardsLedger', 'internalId', internalId)
            const localVarPath = `/api/v1/company/rewards/ledger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (internalId !== undefined) {
                localVarQueryParameter['internalId'] = internalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aggregated rewards analytics
         * @param {string} [period] 
         * @param {string} [hierarchyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsStats: async (period?: string, hierarchyId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/rewards/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (hierarchyId !== undefined) {
                localVarQueryParameter['hierarchyId'] = hierarchyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List catalog items (admin)
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRewardsCatalog: async (includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/rewards/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List redemptions, optionally by status
         * @param {RedemptionStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRewardsRedemptions: async (status?: RedemptionStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/rewards/redemptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve, deliver, reject or cancel a redemption
         * @param {string} redemptionId 
         * @param {string} action 
         * @param {RedemptionTransitionRequest} [redemptionTransitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitionRewardsRedemption: async (redemptionId: string, action: string, redemptionTransitionRequest?: RedemptionTransitionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redemptionId' is not null or undefined
            assertParamExists('transitionRewardsRedemption', 'redemptionId', redemptionId)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('transitionRewardsRedemption', 'action', action)
            const localVarPath = `/api/v1/company/rewards/redemptions/{redemptionId}`
                .replace(`{${"redemptionId"}}`, encodeURIComponent(String(redemptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redemptionTransitionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a catalog item
         * @param {string} itemId 
         * @param {RewardCatalogItemRequest} rewardCatalogItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRewardsCatalogItem: async (itemId: string, rewardCatalogItemRequest: RewardCatalogItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('updateRewardsCatalogItem', 'itemId', itemId)
            // verify required parameter 'rewardCatalogItemRequest' is not null or undefined
            assertParamExists('updateRewardsCatalogItem', 'rewardCatalogItemRequest', rewardCatalogItemRequest)
            const localVarPath = `/api/v1/company/rewards/catalog/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rewardCatalogItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the rewards configuration
         * @param {RewardsConfiguration} rewardsConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRewardsConfig: async (rewardsConfiguration: RewardsConfiguration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rewardsConfiguration' is not null or undefined
            assertParamExists('updateRewardsConfig', 'rewardsConfiguration', rewardsConfiguration)
            const localVarPath = `/api/v1/company/rewards/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rewardsConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a batch of gift-card codes (CSV, one code per line)
         * @param {string} itemId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRewardsCodes: async (itemId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('uploadRewardsCodes', 'itemId', itemId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadRewardsCodes', 'file', file)
            const localVarPath = `/api/v1/company/rewards/catalog/{itemId}/codes`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardsApi - functional programming interface
 * @export
 */
export const RewardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RewardsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Manually adjust an employee\'s points
         * @param {PointsAdjustmentRequest} pointsAdjustmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjustRewardsPoints(pointsAdjustmentRequest: PointsAdjustmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjustRewardsPoints(pointsAdjustmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.adjustRewardsPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a catalog item
         * @param {RewardCatalogItemRequest} rewardCatalogItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRewardsCatalogItem(rewardCatalogItemRequest: RewardCatalogItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardCatalogItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRewardsCatalogItem(rewardCatalogItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.createRewardsCatalogItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a catalog item (archived if it has redemptions)
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRewardsCatalogItem(itemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRewardsCatalogItem(itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.deleteRewardsCatalogItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the rewards configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardsConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardsConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardsConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getRewardsConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List an employee\'s points ledger
         * @param {number} internalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardsLedger(internalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PointsLedgerEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardsLedger(internalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getRewardsLedger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aggregated rewards analytics
         * @param {string} [period] 
         * @param {string} [hierarchyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardsStats(period?: string, hierarchyId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardsStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardsStats(period, hierarchyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getRewardsStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List catalog items (admin)
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRewardsCatalog(includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RewardCatalogItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRewardsCatalog(includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.listRewardsCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List redemptions, optionally by status
         * @param {RedemptionStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRewardsRedemptions(status?: RedemptionStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Redemption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRewardsRedemptions(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.listRewardsRedemptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Approve, deliver, reject or cancel a redemption
         * @param {string} redemptionId 
         * @param {string} action 
         * @param {RedemptionTransitionRequest} [redemptionTransitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transitionRewardsRedemption(redemptionId: string, action: string, redemptionTransitionRequest?: RedemptionTransitionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Redemption>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transitionRewardsRedemption(redemptionId, action, redemptionTransitionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.transitionRewardsRedemption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a catalog item
         * @param {string} itemId 
         * @param {RewardCatalogItemRequest} rewardCatalogItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRewardsCatalogItem(itemId: string, rewardCatalogItemRequest: RewardCatalogItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardCatalogItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRewardsCatalogItem(itemId, rewardCatalogItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.updateRewardsCatalogItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the rewards configuration
         * @param {RewardsConfiguration} rewardsConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRewardsConfig(rewardsConfiguration: RewardsConfiguration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardsConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRewardsConfig(rewardsConfiguration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.updateRewardsConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a batch of gift-card codes (CSV, one code per line)
         * @param {string} itemId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadRewardsCodes(itemId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GiftCardBatchUploadResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadRewardsCodes(itemId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.uploadRewardsCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RewardsApi - factory interface
 * @export
 */
export const RewardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RewardsApiFp(configuration)
    return {
        /**
         * 
         * @summary Manually adjust an employee\'s points
         * @param {PointsAdjustmentRequest} pointsAdjustmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustRewardsPoints(pointsAdjustmentRequest: PointsAdjustmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adjustRewardsPoints(pointsAdjustmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a catalog item
         * @param {RewardCatalogItemRequest} rewardCatalogItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRewardsCatalogItem(rewardCatalogItemRequest: RewardCatalogItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<RewardCatalogItem> {
            return localVarFp.createRewardsCatalogItem(rewardCatalogItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a catalog item (archived if it has redemptions)
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRewardsCatalogItem(itemId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRewardsCatalogItem(itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the rewards configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsConfig(options?: RawAxiosRequestConfig): AxiosPromise<RewardsConfiguration> {
            return localVarFp.getRewardsConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List an employee\'s points ledger
         * @param {number} internalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsLedger(internalId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PointsLedgerEntry>> {
            return localVarFp.getRewardsLedger(internalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aggregated rewards analytics
         * @param {string} [period] 
         * @param {string} [hierarchyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsStats(period?: string, hierarchyId?: string, options?: RawAxiosRequestConfig): AxiosPromise<RewardsStats> {
            return localVarFp.getRewardsStats(period, hierarchyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List catalog items (admin)
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRewardsCatalog(includeArchived?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<RewardCatalogItem>> {
            return localVarFp.listRewardsCatalog(includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List redemptions, optionally by status
         * @param {RedemptionStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRewardsRedemptions(status?: RedemptionStatus, options?: RawAxiosRequestConfig): AxiosPromise<Array<Redemption>> {
            return localVarFp.listRewardsRedemptions(status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve, deliver, reject or cancel a redemption
         * @param {string} redemptionId 
         * @param {string} action 
         * @param {RedemptionTransitionRequest} [redemptionTransitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitionRewardsRedemption(redemptionId: string, action: string, redemptionTransitionRequest?: RedemptionTransitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Redemption> {
            return localVarFp.transitionRewardsRedemption(redemptionId, action, redemptionTransitionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a catalog item
         * @param {string} itemId 
         * @param {RewardCatalogItemRequest} rewardCatalogItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRewardsCatalogItem(itemId: string, rewardCatalogItemRequest: RewardCatalogItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<RewardCatalogItem> {
            return localVarFp.updateRewardsCatalogItem(itemId, rewardCatalogItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the rewards configuration
         * @param {RewardsConfiguration} rewardsConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRewardsConfig(rewardsConfiguration: RewardsConfiguration, options?: RawAxiosRequestConfig): AxiosPromise<RewardsConfiguration> {
            return localVarFp.updateRewardsConfig(rewardsConfiguration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a batch of gift-card codes (CSV, one code per line)
         * @param {string} itemId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRewardsCodes(itemId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<GiftCardBatchUploadResult> {
            return localVarFp.uploadRewardsCodes(itemId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RewardsApi - object-oriented interface
 * @export
 * @class RewardsApi
 * @extends {BaseAPI}
 */
export class RewardsApi extends BaseAPI {
    /**
     * 
     * @summary Manually adjust an employee\'s points
     * @param {PointsAdjustmentRequest} pointsAdjustmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public adjustRewardsPoints(pointsAdjustmentRequest: PointsAdjustmentRequest, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).adjustRewardsPoints(pointsAdjustmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a catalog item
     * @param {RewardCatalogItemRequest} rewardCatalogItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public createRewardsCatalogItem(rewardCatalogItemRequest: RewardCatalogItemRequest, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).createRewardsCatalogItem(rewardCatalogItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a catalog item (archived if it has redemptions)
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public deleteRewardsCatalogItem(itemId: string, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).deleteRewardsCatalogItem(itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the rewards configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getRewardsConfig(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getRewardsConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List an employee\'s points ledger
     * @param {number} internalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getRewardsLedger(internalId: number, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getRewardsLedger(internalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aggregated rewards analytics
     * @param {string} [period] 
     * @param {string} [hierarchyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getRewardsStats(period?: string, hierarchyId?: string, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getRewardsStats(period, hierarchyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List catalog items (admin)
     * @param {boolean} [includeArchived] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public listRewardsCatalog(includeArchived?: boolean, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).listRewardsCatalog(includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List redemptions, optionally by status
     * @param {RedemptionStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public listRewardsRedemptions(status?: RedemptionStatus, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).listRewardsRedemptions(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve, deliver, reject or cancel a redemption
     * @param {string} redemptionId 
     * @param {string} action 
     * @param {RedemptionTransitionRequest} [redemptionTransitionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public transitionRewardsRedemption(redemptionId: string, action: string, redemptionTransitionRequest?: RedemptionTransitionRequest, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).transitionRewardsRedemption(redemptionId, action, redemptionTransitionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a catalog item
     * @param {string} itemId 
     * @param {RewardCatalogItemRequest} rewardCatalogItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public updateRewardsCatalogItem(itemId: string, rewardCatalogItemRequest: RewardCatalogItemRequest, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).updateRewardsCatalogItem(itemId, rewardCatalogItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the rewards configuration
     * @param {RewardsConfiguration} rewardsConfiguration 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public updateRewardsConfig(rewardsConfiguration: RewardsConfiguration, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).updateRewardsConfig(rewardsConfiguration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a batch of gift-card codes (CSV, one code per line)
     * @param {string} itemId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public uploadRewardsCodes(itemId: string, file: File, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).uploadRewardsCodes(itemId, file, options).then((request) => request(this.axios, this.basePath));
    }
}

